import {AfterContentInit, ContentChild, Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgForm, ValidationErrors} from '@angular/forms';
import {FormButtonsComponent} from '../form-buttons/form-buttons.component';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'form[bijbForm]',
    standalone: true
})
export class BijbFormDirective implements AfterContentInit {
  private _submitted = false;

  constructor(private form: NgForm, private element: ElementRef) {
  }

  @ContentChild(FormButtonsComponent)
  private formButtons: FormButtonsComponent;

  @Input() set formHidden(value: boolean) {
    if (value === true) {
      this.submitted = false;
      this.updateButtonsState();

      if (this.formButtons) {
        this.formButtons.errorMessage = '';
      }
    }
  }

  @Input()
  public valid = true;

  private get submitted(): boolean {
    return this._submitted;
  }

  private set submitted(value: boolean) {
    this._submitted = value;
    if (value) {
      (this.element.nativeElement as HTMLFormElement).classList.add('submitted');
    } else {
      (this.element.nativeElement as HTMLFormElement).classList.remove('submitted');
      (this.form as any).submitted = false;
    }
  }

  @Output()
  public bijbSubmit: EventEmitter<void> = new EventEmitter();

  @HostListener('input')
  public onInput(): void {
    this.form.form.markAsDirty();
    this.submitted = false;
    this.updateButtonsState();
  }

  @HostListener('ngSubmit')
  public onSubmit(): boolean {
    this.submitted = true;

    if (this.form.form.valid) {
      this.bijbSubmit.emit();
      this.form.form.markAsPristine();
    } else {
      this.formButtons.errorMessage = this.getErrorMessage();
    }

    this.updateButtonsState();

    return false;
  }

  public ngAfterContentInit(): void {
    if (this.formButtons) {
      this.formButtons.reset.subscribe(() => {
        this.form.form.markAsPristine();
        this.submitted = false;
      });
    }

    this.form.statusChanges.subscribe(valid => {
      this.updateButtonsState();
    });
  }

  private updateButtonsState(): void {
    if (this.formButtons) {
      this.formButtons.disabled = this.form.pristine;
      this.formButtons.success = this.valid && this.submitted && this.form.pristine;
    }
  }

  private getErrorMessage(): string {
    const errors = Object.assign({
      urlInvalid: 'Die link is niet geldig. Zorg dat de URL begint met http:// of https://.'
    })

    let error: string = '';
    for (let key of Object.keys(this.form.form.controls)) {
      const controlErrors: ValidationErrors = this.form.form.get(key).errors;
      if (controlErrors != null) {
        error = errors[Object.keys(controlErrors)[0]];
        break;
      }
    }

    return error || '';
  }
}
